<template>
  <div>
    <!-- 上传 -->
    <div class="mtb" v-if="!isShowYL">
      <!-- 1行 -->
      <div class="rows">
        <div class="rowLeft">1,下载配载导入模板并填写信息</div>
        <div class="rowRight">
          <el-button class="btns glo_bgcMainColor" @click="downLoadYD">下载配载模板</el-button>
        </div>
      </div>
      <div class="rows">
        <div class="rowLeft">2,上传填写完整的配载模板</div>
        <div class="rowRight">
          <el-button class="btns" @click="uploadMaterial">上传文件</el-button>
          <div class="filenames">{{ fileName }}</div>
          <div v-if="fileName">
            <i v-if="!isFileSuccess" class="el-icon-loading"></i>
            <i v-else style="color: #00c297" class="el-icon-success"></i>
          </div>
        </div>
      </div>
      <div class="rows">
        <div class="rowLeft"></div>
        <div class="rowRight">
          <el-button class="btns glo_bgcMainColor" @click="goDetails">导入预览</el-button>
          <el-button class="btns" @click="ResetBtns">重置</el-button>
        </div>
      </div>
    </div>

    <!-- 预览 -->
    <div class="pagesBox" v-if="isShowYL">
      <div style="height: 60px; width: 100%"></div>
      <div class="topBtns">
        <el-button style="margin-top: 10px" class="glo_bgcMainColor" @click="saveBtns">确认导入</el-button>
        <el-button style="margin-top: 10px" class @click="isShowYL = false">关闭预览</el-button>
      </div>

      <!-- 表格 -->
      <div class="glo_Table">
        <!-- 配载信息 -->
        <el-table :height="tableHeigth" header-align="center" ref="mytable" :data="tableData" border stripe :highlight-current-row="true" show-summary :summary-method="getSummaries">
          <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
          <template v-for="(item, index) in myTableHeard">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item.field == 'isError' && item.isShow"
            >
              <template slot-scope="scope">
                <div class="errorClaaa" v-if="scope.row.isError == 1">是</div>
                <div v-else>否</div>
              </template>
            </el-table-column>
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-else-if="item.field == 'errorReason' && item.isShow"
            >
              <template slot-scope="scope">
                <div class="errorClaaa">{{ scope.row.errorReason }}</div>
              </template>
            </el-table-column>
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-else-if="item && item.isShow"
            >
              <el-table-column
                v-for="(item2, idx2) in item.childLists"
                :key="idx2"
                :label="item2.name"
                :prop="item2.field"
                align="center"
                :show-overflow-tooltip="true"
                :min-width="item2.width"
                :data-isTotal="item2.isTotal"
              ></el-table-column>
            </el-table-column>
          </template>
          <el-table-column fixed="right" label="操作" min-width="120px">
            <template slot-scope="scope">
              <div class="tabRightBtns">
                <el-button class="rbtns" @click.stop="editBtns(scope.row, scope.$index)">修改</el-button>
                <el-button class="rbtns" @click.stop="delBtns(scope.row, scope.$index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 上传组件 -->
    <input type="file" style="display: none" ref="file" @click="
        (e) => {
          e.target.value = '';
        }
      " @change="getFileData" />
    <uploadimgs style="display: none" @input="changeFileList" :fileNameLists="fileNameLists" :limit="1"></uploadimgs>
    <!-- 弹窗 修改配载 -->
    <myDialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="handleCloseDia" @diaConfirmBtn="diaConfirmBtn">
      <div class="glo_dialogForm">
        <el-form class="diaForm" v-if="isShowDialog" ref="dialogFormRef1" :model="dialogForm" label-width="100px">
          <el-form-item class="dialogFormItems queryItems" label="是否报错:">
            <el-select clearable filterable v-model="dialogForm.isError" placeholder="请选择" disabled>
              <el-option v-for="(item, index) in isErrorList" :key="index" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="dialogForm.isError == 1" class="dislogFormTextarea" prop="errorReason" label="错误原因:">
            <el-input type="textarea" rows="2" v-model="dialogForm.errorReason"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="taskNumber" label="计划任务编号:">
            <el-input type="text" v-model="dialogForm.taskNumber"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="dispatchNumber" label="虚拟批次号:">
            <el-input type="text" v-model="dialogForm.dispatchNumber"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="sort" label="排序:">
            <el-input type="text" v-model="dialogForm.sort"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>
<script>
import uploadimgs from "@/components/upLoadImgs.vue";
import myDialog from "@/components/Dialog.vue";
export default {
  components: {
    myDialog,
    uploadimgs,
  },
  data() {
    return {
      listType: "text",
      fileName: "",
      isFileSuccess: false,
      itemFile: "",
      waybillFile: "",
      isShowYL: false, //是否预览
      // 预览的
      tableHeigth: "75vh",
      myTableHeard: [
        {
          name: "是否错误",
          field: "isError",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "错误原因",
          field: "errorReason",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "计划任务编号",
          field: "taskNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "虚拟批次号",
          field: "dispatchNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "排序",
          field: "sort",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      tableData: [],
      totalArr: [],
      // 弹窗1
      diaWidth: "80%",
      dialogTitle: "修改配载信息",
      isShowDialog: false,
      dialogForm: {
        // isError
      },
      idx: null,
      isErrorList: [
        {
          val: 1,
          name: "是",
        },
        {
          val: 0,
          name: "否",
        },
      ],
      groupName: "peiZaiMuBan",
      templateName: "配载导入模板.xlsx",
      fileNameId: "793963369d811f78dd0cb4c3558e53d1.xlsx", //文件id
      fileNameLists: [],
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      this.tableHeigth = windonHeight - 141 + "px";
      console.log("tableHeigth", this.tableHeigth);
    });
  },
  activated() {},
  destroyed() {},
  methods: {
    // 选择图片
    changeFileList(array) {
      console.log("array", array);
      this.fileNameLists = array;
      let fileName = array[0].name || "";
      this.$API
        .saveExportTemplate({
          groupName: this.groupName || "",
          templateName: this.templateName || "",
          fileName: fileName || this.fileNameId,
        })
        .then((res) => {
          this.$message.success(res.data.message || "上传成功");
        });
    },
    downLoadYD() {
      // 下载配载模板
      this.$API.wtl_getFileUrl({ fileName: this.fileNameId }).then((res) => {
        let downloadurl = res.data.result.url;
        var a = document.createElement("a");
        a.style.display = "none";
        a.href = downloadurl;
        a.target = "_blank";
        a.setAttribute("download", this.templateName); //指定下载后的文件名，防跳转
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    },
    editBtns(row, idx) {
      this.isShowDialog = true;

      this.dialogForm = JSON.parse(JSON.stringify(row));
      console.log(this.dialogForm);
      this.idx = idx;
    },
    delBtns(row, idx) {
      this.$confirm(
        "确定删除该条数据吗? 配载号为: " + row.waybillNumber,
        "提示:"
      )
        .then((res) => {
          let d = JSON.parse(JSON.stringify(this.tableData));
          d.splice(idx, 1);
          this.tableData = d;
        })
        .catch(() => {});
    },
    goDetails() {
      if (!this.waybillFile) {
        this.$message.error("请上传配载模板");
        return false;
      }
      const form = new FormData(); //  根据后台需求数据格式
      form.append("file", this.waybillFile); //
      this.$showLoading();
      this.$API.importDispatchTaskSortV3(form).then((res) => {
        this.$hideLoading();
        let datas = res.data.result || "";
        if (datas) {
          this.tableData = datas.dataList || []; //配载信息
        }
        this.isShowYL = true;
      });
    },

    // 重置
    ResetBtns() {
      this.fileName = "";
      this.isFileSuccess = false;
      this.itemFile = "";
      this.waybillFile = "";
    },
    //  上传
    uploadMaterial(type) {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    // 触发上传材料文件
    getFileData() {
      const inputFile = this.$refs.file.files[0];
      const file = inputFile;
      const fileName = inputFile.name;
      this.isFileSuccess = true;
      this.fileName = fileName;
      this.waybillFile = file;
    },

    // 预览部分的

    // 确定导入
    saveBtns() {
      let chartsArray = this.tableData.filter((item) => item.errorReason) || [];
      console.log("chartsArray", chartsArray);
      if (chartsArray.length > 0) {
        this.$message.warning("还存在错误的数据,请修改完后重新提交");
        return false;
      }
      this.$API
        .importDispatchTaskSortSureV3({
          dataList: this.tableData,
        })
        .then((res) => {
          let datas = res.data.result || "";
          console.log("res", datas);
          if (datas) {
            this.tableData = datas.dataList || []; //配载信息
            this.$message.error(res.data.message || "导入失败");
          } else {
            setTimeout(() => {
              this.isShowYL = false;
            }, 1000);
            this.$message.success(res.data.message || "导入成功");
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {};
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      let arrs = [this.dialogForm];
      this.$API
        .importDispatchTaskSortCheckV3({
          dataList: arrs,
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          let datas = JSON.parse(JSON.stringify(this.tableData));
          datas[this.idx] = res.data.result.dataList[0];
          this.isShowDialog = false;
          this.$nextTick(() => {
            this.tableData = datas;
            this.$refs.mytable.doLayout();
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped lang='less'>
@borderd7: #d7d7d7;
.mtb {
  width: 80%;
  margin: 30px auto;
  border: 1px solid @borderd7;
  border-radius: 4px;

  .rows {
    display: flex;
    height: 40px;
    align-items: center;
    box-sizing: border-box;

    .rowLeft,
    .rowRight {
      flex: 1;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid @borderd7;
      padding: 0 10px;
    }
    .rowLeft {
      border-right: 1px solid @borderd7;
      text-align: center;
    }
    .rowRight {
      display: flex;
      align-items: center;
      .btns {
        padding: 8px 10px;
      }

      .filenames {
        margin: 0 10px;
        text-decoration: underline;
      }
    }
  }
}

.topBtns {
  width: calc(100% - 270px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}

.errorClaaa {
  color: #f00;
  text-overflow: ellipsis;
  overflow: hidden;
}

.tablerTitle {
  // width: 90%;
  height: 30px;
  line-height: 30px;
  background-color: #f2f2f2;
  padding: 10px;
  border-bottom: px solid #fff;
  font-weight: bold;
}

.diaForm {
  /deep/ .el-select {
    width: 100%;
  }
}
</style>